import React, { PureComponent } from 'react'
import { withStyles } from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableFooter from '@material-ui/core/TableFooter'
import TableHead from '@material-ui/core/TableHead'
import TablePagination from '@material-ui/core/TablePagination'
import TableRow from '@material-ui/core/TableRow'
import TableSortLabel from '@material-ui/core/TableSortLabel'
import LocationIcon from '@material-ui/icons/LocationSearching'
import Tooltip from '../components/Tooltip'

const styles = theme => ({
  root: {},
  table: {
    display: 'inline-block'
  },
  body: {
    height: '200px',
    display: 'inline-block',
    overflowY: 'scroll',
    fontSize: 'small'
  },
  cell: theme.typography.caption,
  footer: {},
  button: {
    color: 'gray',
    padding: 0,
    margin: 0
  },
  icon: {
    width: '0.75rem'
  },
  name: {},
  highlighted: {
    background: theme.palette.background.contentFrame
  }
})

class DataTable extends PureComponent {
  constructor (props, context) {
    const { data } = props

    super(props, context)

    this.state = {
      data,
      descending: true,
      orderBy: null,
      page: 0,
      rowsPerPage: 5
    }
  }

  componentWillReceiveProps (nextProps) {
    const { data } = nextProps
    const { descending, orderBy } = this.state
    const sortedData = orderBy ? this.sort(data, !descending, orderBy) : data
    this.setState({ data: sortedData })
  }

  getHeaders = data => {
    const { filter = i => i } = this.props
    const headers = Object.keys(data[0]).filter(filter)

    return headers
  }

  handleChangePage = (event, page) => {
    this.setState({ page })
  }

  handleChangeRowsPerPage = event => {
    this.setState({ rowsPerPage: event.target.value })
  }

  handleRequestSort = (event, property) => {
    const { data, descending } = this.state
    const orderBy = event.target.getAttribute('name')

    const sortedData = this.sort(data, descending, orderBy)

    this.setState({ data: sortedData, descending: !descending, orderBy })
  }

  sort = (data, descending, orderBy) => {
    return descending
      ? data.slice().sort((a, b) => (b[orderBy] < a[orderBy] ? -1 : 1))
      : data.slice().sort((a, b) => (a[orderBy] < b[orderBy] ? -1 : 1))
  }

  handleZoomToObject = object => {
    const { handleZoomToObject } = this.props
    handleZoomToObject(object)
  }

  handleRowClicked = event => {
    const { handleRowClicked } = this.props
    handleRowClicked(event)
  }

  handleMouseEnter = event => {
    const { handleMouseEnter } = this.props
    handleMouseEnter(event)
  }

  handleMouseLeave = event => {
    const { handleMouseLeave } = this.props
    handleMouseLeave(event)
  }

  render () {
    const { classes, columns, uuidsSelected, uuidsHighlighted } = this.props
    const { data, descending, orderBy, page, rowsPerPage } = this.state

    if (!data || data.constructor !== Array) {
      return null
    }

    return (
      <Table className={classes.table}>
        <TableHead>
          <TableRow>
            {
              <TableCell
                className={classes.button}
                key={'location'}
                padding='dense'
              />
            }
            {columns.map((column, index) => (
              <TableCell key={index} numeric={column.numeric} padding={'dense'}>
                <TableSortLabel
                  key={index}
                  active={orderBy === column.name}
                  name={column.name}
                  direction={descending ? 'desc' : 'asc'}
                  onClick={this.handleRequestSort}
                >
                  {column.label}
                </TableSortLabel>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {data
            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            .map((datum, index) => {
              return (
                <TableRow
                  key={index}
                  name={datum.well_name}
                  className={
                    uuidsHighlighted.includes(datum.uuid)
                      ? classes.highlighted
                      : null
                  }
                  onClick={this.handleRowClicked}
                  onMouseEnter={this.handleMouseEnter}
                  onMouseLeave={this.handleMouseLeave}
                  hover
                  selected={uuidsSelected.includes(datum.uuid)}
                >
                  {
                    <TableCell
                      className={classes.button}
                      key={'location'}
                      padding={'dense'}
                    >
                      <Tooltip id={'locationIcon'} title={'zoom to location'}>
                        <LocationIcon
                          onClick={() => this.handleZoomToObject(datum)}
                          color='inherit'
                          className={classes.icon}
                        />
                      </Tooltip>
                    </TableCell>
                  }
                  {columns.map((column, index) => (
                    <TableCell
                      key={index}
                      numeric={column.numeric}
                      padding={'dense'}
                      className={classes.cell}
                      value={datum.well_name}
                      uuid={datum.uuid}
                    >
                      {column.format(datum[column.name])}
                    </TableCell>
                  ))}
                </TableRow>
              )
            })}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination
              count={data.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onChangePage={this.handleChangePage}
              onChangeRowsPerPage={this.handleChangeRowsPerPage}
            />
          </TableRow>
        </TableFooter>
      </Table>
    )
  }
}

export default withStyles(styles)(DataTable)



// WEBPACK FOOTER //
// ./src/tables/DataTable.js